module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"template_title":"Fragenkatalog","template_description":"Audit Vorbereitung - TEMPLATE"},"en":{"template_title":"Audit-Template","template_description":"Audit Preparation - TEMPLATE"}}')
  delete Component.options._Ctor
}
